<template>
  <div class="outer-page">
    <navigation class="header" @click="
      $report({
        id: 50027,
        args: { step: status }
    })"
    ></navigation>
    <div class="page">
      <!-- <div class="back">
                <div class="click-area" :style="{marginTop:statusBarHeight+'px'}">
                    <img
                        @click="back"
                        src="../images/btn_fanhui.png"
                        srcset="
                            ../images/btn_fanhui@2x.png 2x,
                            ../images/btn_fanhui@3x.png 3x
                        "
                        v-stat="{ id: 50027, args: { step: status } }"
                    />
                </div>
            </div> -->
      <header>
        <img
          class="logo"
          src="../../user/images/logo.png"
          srcset="
                        ../../user/images/logo@2x.png 2x,
                        ../../user/images/logo@3x.png 3x
                    "
        />
        <div
          class="rule-button"
          @click="goActivityRule"
          v-stat="{ id: 50026, args: { step: status } }"
        >
          <span class="rule-button-icon">?</span>活动规则
        </div>
      </header>

      <section>
        <div class="title">
          <img
            src="./images/img_title.png"
            srcset="
                            ./images/img_title@2x.png 2x,
                            ./images/img_title@3x.png 3x
                        "
          />
        </div>
        <div class="paragragh bg" v-if="status === 0">
          只差一步：领最高1500元免息红包
        </div>
        <div class="paragragh" v-else-if="status === 1">
          {{ couponExpire | date('YYYY/MM/DD') }}前完成借款有效
        </div>
        <div class="paragragh" v-else-if="status === 2"></div>
        <div class="main turntable" v-if="status === 0">
          <div
            class="button"
            @click="startGoodLuck"
            v-stat="{ id: 50025 }"
          ></div>
        </div>
        <template v-else-if="status === 1">
          <div class="main" v-if="!placeholder">
            <div
              class="tag"
              @click="
                navigateTo({
                  h5: ['USED', 'CREDIT_LOCKED', 'LOAN_LOCKED','TIMEOUT'].includes(couponStatus) ? '/quan/history' : '/quan/list',
                  voucher:true
                  // native: ['USED', 'LOCKED', 'TIMEOUT'].includes(couponStatus) ? 'coupon_list_history' : 'coupon_list',
                })
              "
              v-stat="{ id: 50035, args: {step: status} }"
            >
              查看券包
            </div>
            <div class="text">
              <div>
                <span class="DIN">{{ day }}</span>天
              </div>
              <div>免息红包</div>
            </div>
            <div
              class="button"
              @click="
                navigateTo(nextNode)
              "
              v-stat="{ id: 50034 }"
            >
              申请借款领红包
            </div>
          </div>
          <div class="placeholder" v-else></div>
        </template>
        <div class="main" v-else-if="status === 2">
          <div class="text">
            <div>
              <span class="DIN">{{ day }}</span>天
            </div>
            <div>免息红包</div>
          </div>
          <div
            class="button"
            @click="
              navigateTo({
                h5: ['USED', 'LOAN_LOCKED', 'CREDIT_LOCKED', 'TIMEOUT'].includes(couponStatus) ? '/quan/history' : '/quan/list',
                voucher:true
                // native: ['USED', 'LOCKED', 'TIMEOUT'].includes(couponStatus) ? 'coupon_list_history' : 'coupon_list',
              })
            "
            v-stat="{ id: 50035, args: {step: status} }"
          >
            查看券包
          </div>
        </div>
        <div class="raiders">
          <img
            src="./images/img_raiders.png"
            srcset="
                            ./images/img_raiders@2x.png 2x,
                            ./images/img_raiders@3x.png 3x
                        "
          />
        </div>
      </section>
      <footer>活动所有解释权归天美贷所有</footer>
      <nd-dialog
        v-model="dialog1"
        :footer="false"
        :closeBtn="true"
        @close="closeDialog1"
      >
        <div class="dialog1-content" slot="custom">
          <p>
            获得授信额度才能开启免息红包哦！<br />快去发起授信申请吧！
          </p>
          <div
            class="button"
            @click="navigateTo(nextNode)"
            v-stat="{ id: 50029 }"
          >
            申请授信
          </div>
        </div>
      </nd-dialog>
      <nd-dialog
        v-model="dialog2"
        :footer="false"
        :closeBtn="true"
        @close="closeDialog2"
      >
        <div class="dialog2-content" slot="custom">
          <p class="title">
            抱歉，您尚未获得授信额度！
          </p>
          <p>
            您当前处于授信封禁期，<br />请于{{
              lockingDay | date('YYYY/MM/DD')
            }}重新发起授信，<br />获得额度后再来领红包吧！
          </p>
          <div
            class="button"
            @click="navigateTo(nextNode)"
            v-stat="{ id: 50032 }"
          >
            查看授信结果
          </div>
        </div>
      </nd-dialog>
      <turntable
        ref="turntable"
        :day="day"
        @animationEnd="animationEnd"
      ></turntable>
    </div>
  </div>
</template>
<script>
import { jsBridge, hasNativeMethod } from '@/assets/jsBridge'
import { mapState, mapActions } from 'vuex'
import { judgeClientSystem } from '../../../assets/utils'
import Turntable from './components/turntable'

export default {
  name: 'activity-interest-free',
  components: { Turntable },
  customReadyNotify: true,
  data () {
    return {
      day: 0,
      status: -1, // 0->未授信，1->授信成功15日内未成功借款，2->授信橙红15日内已成功借款
      qualification: false,
      activeType: 'REDUCTION_INTEREST',
      couponStatus: 'PRE_PROVIDE',
      nextStep: null,
      couponExpire: null,
      dialog1: false, // 引导授信弹窗
      dialog2: false,
      placeholder: false,
      couponId: null,
      relationId: null,
      preShow: 'N'
    }
  },
  computed: {
    ...mapState('user', {
      creditStatus: (state) => state.quotaInfo.creditStatus,
      lockingDay: (state) => state.quotaInfo.lockingDay,
      loanStatus: (state) => state.quotaInfo.loanStatus
    }),
    ...mapState({
      statusBarHeight: state => state.statusBarHeight - 15
    }),
    nextNode () {
      switch (this.nextStep) {
        case 'OCR':
          return { h5: '/authentication/id', native: 'ocr' }
        case 'INFO':
          return { h5: '/authentication/base', native: 'basic_info' }
        case 'CREDIT':
          return {
            h5: '/authentication/base',
            native: 'basic_info'
          }
        case 'CREDIT_REVIEW':
          return {
            h5: `/authentication/result?applyNo=${this.relationId}`
          }
        case 'CREDIT_LOCKED':
          return {
            h5: `/authentication/result?applyNo=${this.relationId}`
          }
        case 'LOAN':
          return { h5: '/withdraw/index', native: 'withdraw' }
        case 'LOAN_LOCKED':
        case 'LOANING':
        case 'LOAN_REFUSED':
        case 'LOAN_WAIT_VIP':
          return {
            h5: `/withdraw/result?loanApplyNo=${this.relationId}`
          }
        case 'LOAN_PASSED':
          return { h5: '/repayment', native: 'repayment' }
        default:
          return { h5: '/authentication/id', native: 'ocr' }
      }
    }
  },
  async created () {
    // await this.getActiveDetail()
    await this.getLimitX({ loanPlatform: 'TMD' })
    if (this.couponId) await this.getCouponDetail()
    this.$report({
      id: 10002,
      args: {
        screen: 'page_active_interest_free',
        visible: 1,
        step: this.status
      }
    })
    this.$bus.$emit('ready')
  },
  methods: {
    ...mapActions('user', ['getLimitX']),

    ...mapActions('activities', [
      'qualificationCouponX',
      'couponDetailX',
      'activeCouponX',
      'saveCouponPreShow'
    ]),
    animationEnd () {
      this.placeholder = false
      this.$report({
        id: 50033,
        visible: 0
      })
      this.saveCouponPreShow({
        couponRecordId: this.couponId
      })
    },
    back () {
      if (hasNativeMethod('exit') && judgeClientSystem() !== 'IOS') {
        jsBridge('exit')
      } else {
        this.$router.back()
      }
    },
    goActivityRule () {
      this.$router.push(`/activities/interest-free/rule`)
    },
    async getCouponDetail () {
      const res = await this.couponDetailX({
        couponRecordId: this.couponId
      })
      this.couponDetail = res.data || {}
      this.couponStatus = this.couponDetail.status
      this.day = this.couponDetail.discountValue
      this.couponExpire = this.couponDetail.endTime

      if (this.couponStatus === 'PRE_PROVIDE' || !this.couponStatus) {
        this.status = 1
      } else {
        this.status = 2
      }
      // 当 有资格 && 状态为预分配 && 未进行过动画 时才进行动画转圈，并且转圈后请求接口将preShow修改为Y
      if (this.qualification && this.couponStatus === 'PRE_PROVIDE' && this.preShow === 'N') {
        this.placeholder = true
        this.$refs.turntable.open()
        this.$report({
          id: 50033,
          visible: 1
        })
      }
    },
    async getActiveDetail () {
      const res = await this.qualificationCouponX({
        activeType: this.activeType
      })
      if (res.data[0]) {
        this.qualification = res.data[0].qualification
        this.couponId = res.data[0].couponRecordId
        this.nextStep = res.data[0].nextStep
        this.relationId = res.data[0].relationId
        this.preShow = res.data[0].preShow
        if (['OCR', 'INFO', 'CREDIT', 'CREDIT_LOCKED', 'LOAN_LOCKED', 'LOCKED', 'CREDIT_REVIEW', 'UNCREDIT'].includes(this.nextStep)) {
          this.status = 0
        }
      }
    },
    routerTo (path) {
      this.$router.push(path)
    },
    navigateTo (path) {
      // if (path.native === 'withdraw') {
      //     if (this.loanStatus === 'LOANING') return this.$message('当前有放款中订单，暂时不能去借款哦')
      //     if (this.creditStatus === 'LOAN_REFUSED') return this.$message('提现封禁中，暂不能提现')
      // }
      // if (this.nextStep === 'LOANING' && !path.voucher) return this.$message('提现审核中，暂不能提现')
      // if (this.nextStep === 'CREDIT_REVIEW' && !path.voucher) return this.$message('授信审核中，暂不能提现')
      if (hasNativeMethod('navigateTo') && !!path.native && judgeClientSystem() !== 'IOS') {
        jsBridge('navigateTo', { path: path.native, exitCurrent: true })
      } else {
        this.$router.push(path.h5)
      }
    },
    startGoodLuck () {
      if (this.creditStatus === 'UNCREDIT') {
        // 引导授信
        this.dialog1 = true
      }
      if (this.creditStatus === 'CREDIT_REFUSED') {
        // 授信封禁提示
        this.dialog2 = true
      }
      if (this.creditStatus === 'CREDIT_REVIEW') {
        this.$router.push(`/authentication/result?applyNo=${this.relationId}`)
      }
    },
    closeDialog1 () {
      this.dialog1 = false
      this.$report({
        id: 50030
      })
    },
    closeDialog2 () {
      this.dialog1 = false
      this.$report({
        id: 50036
      })
    }
  },
  watch: {
    dialog1 (val) {
      this.$report({
        id: 50028,
        args: {
          visible: val ? 1 : 0
        }
      })
    },
    dialog2 (val) {
      this.$report({
        id: 50031,
        args: {
          visible: val ? 1 : 0
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.outer-page{
    height: calc(100% - 110px);
}
.dialog1-content {
    width: 620px;
    height: 450px;
    padding: 0 70px;
    background: rgba(255, 255, 255, 1);
    border-radius: 30px;
    overflow: hidden;
    text-align: center;
    > p {
        margin-top: 150px;
        font-size: 30px;
        color: rgba(51, 51, 51, 1);
        line-height: 42px;
    }
    .button {
        width: 440px;
        height: 80px;
        line-height: 80px;
        margin: 96px auto 0;
        background: linear-gradient(
            90deg,
            rgba(255, 51, 51, 1) 0%,
            rgba(255, 95, 52, 1) 100%
        );
        border-radius: 40px;
        font-size: 32px;
        color: rgba(255, 255, 255, 1);
    }
}
.dialog2-content {
    width: 620px;
    height: 450px;
    padding: 0 70px;
    background: rgba(255, 255, 255, 1);
    border-radius: 30px;
    overflow: hidden;
    text-align: center;
    > p {
        margin-top: 24px;
        font-size: 26px;
        color: rgba(102, 102, 102, 1);
        line-height: 37px;
    }
    .title {
        margin-top: 84px;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 45px;
    }
    .button {
        width: 440px;
        height: 80px;
        line-height: 80px;
        margin: 66px auto 0;
        background: linear-gradient(
            90deg,
            rgba(255, 51, 51, 1) 0%,
            rgba(255, 95, 52, 1) 100%
        );
        border-radius: 40px;
        font-size: 32px;
        color: rgba(255, 255, 255, 1);
    }
}
@keyframes toggle {
    from {
        background: url('./images/img_a.png') center center no-repeat;
        background-size: 100% 100%;
    }
    to {
        background: url('./images/img_b.png') center center no-repeat;
        background-size: 100% 100%;
    }
}
@keyframes rotate {
    from {
        transform: translate3d(-50%, 0, 0) rotate(0deg);
    }
    to {
        transform: translate3d(-50%, 0, 0) rotate(360deg);
    }
}

img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.DIN {
    font-family: DIN-Medium;
    font-weight: 500;
}
.page {
    background: linear-gradient(#ffa43e 70%, #ec6344);
    color: #fff;
    font-size: 28px;
    overflow: hidden;
    .back {
        padding: 0 30px;
        height: 110px;
        justify-content: space-between;
        box-sizing: content-box;
        align-items: center;
        position: relative;
        display: flex;
        z-index: 1000;
        font-size: 36px;
        font-family: PingFangSC-Medium,PingFang SC;
        font-weight: 500;
        color: @fc1;
        .click-area {
            position: fixed;
            z-index: 999;
            top: 50px;
            left: 35px;
            width: 88px;
            height: 76px;
            overflow: hidden;
            > img {
                display: block;
                margin: 20px auto;
                width: 48px;
                height: 36px;
            }
        }
    }
    header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        margin-top: 30px;
        .logo {
            width: 70px;
            height: 70px;
            margin-left: 35px;
        }
        .rule-button {
            display: flex;
            align-items: center;
            font-size: 28px;
            color: rgba(255, 255, 255, 1);
            > span {
                width: 32px;
                height: 32px;
                line-height: 32px;
                margin-right: 5px;
                background-color: rgba(255, 255, 255, 1);
                color: #ffa43e;
                font-weight: 600;
                border-radius: 50%;
                text-align: center;
            }
        }
    }
    section {
        .title {
            width: 100%;
            margin-top: 37px;
        }
        .paragragh {
            margin: auto;
            height: 50px;
            line-height: 50px;
            font-size: 28px;
            color: rgba(255, 255, 255, 1);
            text-align: center;
            &.bg {
                width: 490px;
                background: rgba(253, 111, 42, 1);
                border-radius: 25px;
            }
        }
        .turntable {
            width: 100%;
            height: 812px;
            animation: toggle 0.5s linear infinite;
            background-size: 100% 100%;
        }
        .placeholder {
            width: 100%;
            height: 812px;
        }
        .main {
            position: relative;
            width: 100%;
            height: 812px;
            background: url('./images/img_e.png') center center no-repeat;
            background-size: 100% 100%;
            overflow: hidden;
            .tag {
                position: absolute;
                top: 35px;
                right: 0;
                width: 170px;
                height: 54px;
                line-height: 54px;
                background-color: #ff3933;
                border-radius: 27px 0px 0px 27px;
                font-size: 28px;
                font-weight: 600;
                color: rgba(255, 255, 255, 1);
                text-align: center;
            }
            .text {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                position: absolute;
                top: 185px;
                left: 50%;
                transform: translate3d(-50%, 0, 0);
                width: 310px;
                height: 225px;
                color: #f13729;
                > :first-child {
                    font-size: 50px;
                    line-height: 1;
                }
                > :last-child {
                    font-size: 32px;
                    line-height: 1;
                    margin-top: 13px;
                }
            }
            .button {
                position: absolute;
                top: 674px;
                left: 50%;
                transform: translate3d(-50%, 0, 0);
                width: 460px;
                height: 90px;
                line-height: 90px;
                font-size: 42px;
                font-weight: 600;
                color: rgba(255, 255, 255, 1);
                text-align: center;
            }
        }
        .raiders {
            width: 640px;
            height: 536px;
            margin: 77px auto 0;
        }
    }
    footer {
        font-size: 24px;
        color: #fff;
        text-align: center;
        margin-top: 76px;
        margin-bottom: 57px;
    }
}

.turntable-popup-content {
    position: relative;
    width: 722px;
    height: 759px;
    margin: auto;
    .end {
        position: absolute;
        top: 0;
        left: 50%;
        width: 654px;
        height: 654px;
        transform: translate3d(-50%, 0, 0) rotate(0deg);
    }
    .front {
        position: absolute;
        top: 0;
        bottom: 0;
    }
}
.red-packet {
    &__top {
        position: relative;
        transform-origin: center center;
        // animation: receive 2s forwards;
        .light {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate3d(-50%, 0, 0);
            animation: rotate 1s linear infinite;
            width: 646px;
            height: 604px;
            z-index: 1;
        }
        .packet {
            position: relative;
            width: 459px;
            height: 599px;
            margin: auto;
            z-index: 2;
        }
        .result {
            position: absolute;
            width: 100%;
            top: 400px;
            left: 50%;
            transform: translateX(-50%);
            text-align: center;
            z-index: 3;
            font-size: 30px;
            line-height: 50px;

            .DIN {
                font-size: 70px;
                font-family: DIN-Medium;
                font-weight: 500;
                color: rgba(255, 219, 75, 1);
            }
        }
    }

    &__bottom {
        margin: 287px auto 0;
        width: 146px;
        height: 152px;
    }
}
</style>
